import type { MessageAttachment } from '@/types/conversations'
import { resolveAttachmentMediaUrl } from '@/lib/resolveAttachmentMediaUrl'

import type { AttachmentContext } from './attachmentContext'

interface AudioAttachmentProps {
  attachment: MessageAttachment
  attachmentContext?: AttachmentContext
}

export function AudioAttachment({
  attachment,
  attachmentContext = 'assistant',
}: AudioAttachmentProps) {
  const src = resolveAttachmentMediaUrl(attachment.file_url)
  if (!src) {
    return null
  }

  const showTranscriptionFooter = attachmentContext === 'assistant'

  return (
    <div className="flex min-w-[220px] flex-col gap-1">
      <audio controls src={src} className="w-full" />
      {showTranscriptionFooter ? (
        attachment.transcription ? (
          <p className="text-xs italic text-muted-foreground">🎙 {attachment.transcription}</p>
        ) : (
          <p className="text-xs text-muted-foreground/70">Transcribiendo...</p>
        )
      ) : null}
    </div>
  )
}
